module.exports = __webpack_public_path__ + "img/streaming_champagne.e3c0cf4b.svg";